export default "__VITE_ASSET__gZ13uExw__"